/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RangeGroup } from '../models/RangeGroup';
import type { RangeGroupSort } from '../models/RangeGroupSort';
import type { RangeGuideline } from '../models/RangeGuideline';
import type { RangeName } from '../models/RangeName';
import type { RangeSet } from '../models/RangeSet';
import type { RangeSetSort } from '../models/RangeSetSort';
import type { RangeZone } from '../models/RangeZone';
import type { RangeZoneSort } from '../models/RangeZoneSort';
import type { SalaryRange } from '../models/SalaryRange';
import type { SalaryRangeFile } from '../models/SalaryRangeFile';
import type { SalaryRangesExportTableConfig } from '../models/SalaryRangesExportTableConfig';
import type { SalaryRangeSort } from '../models/SalaryRangeSort';
import type { SalaryRangeTypeOfPay } from '../models/SalaryRangeTypeOfPay';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SalaryRangeService {

    /**
     * Get list of salary ranges
     * @returns SalaryRange Success
     * @throws ApiError
     */
    public static getSalaryRanges({
        requestBody,
    }: {
        /**
         * Parameters for filtering and pagination
         */
        requestBody: {
            /**
             * Filter by plan
             */
            planId?: number;
            /**
             * Filter by range zone
             */
            rangeZoneId?: Array<number>;
            /**
             * Filter by range group
             */
            rangeGroupId?: Array<number>;
            /**
             * Filter by range name
             */
            rangeNameId?: Array<number>;
            /**
             * Filter by type of pay
             */
            typeOfPay?: Array<SalaryRangeTypeOfPay>;
            /**
             * Filter by search string
             */
            search?: string;
            /**
             * Pagination Limit
             */
            limit?: number;
            /**
             * Pagination Offset
             */
            offset?: number;
            /**
             * Sorting
             */
            sort?: SalaryRangeSort;
        },
    }): CancelablePromise<Array<SalaryRange>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/salaryRange',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Reset range
     * @returns any Success
     * @throws ApiError
     */
    public static resetRanges({
        requestBody,
    }: {
        requestBody: {
            planId: number;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/salaryRange/reset',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of SalaryRange's Types of Pay
     * @returns SalaryRangeTypeOfPay Success
     * @throws ApiError
     */
    public static getSalaryRangesTypesOfPay({
        requestBody,
    }: {
        /**
         * Parameters for filtering
         */
        requestBody: {
            /**
             * Filter by plan
             */
            planId?: Array<number>;
            /**
             * Filter by range zone
             */
            rangeZoneId?: Array<number>;
            /**
             * Filter by range group
             */
            rangeGroupId?: Array<number>;
        },
    }): CancelablePromise<Array<SalaryRangeTypeOfPay>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/salaryRange/typeOfPay',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export salary ranges
     * @returns any Success
     * @throws ApiError
     */
    public static exportSalaryRanges({
        requestBody,
    }: {
        requestBody: {
            /**
             * Filter by plan
             */
            planId?: number | null;
            /**
             * Filter by range zone
             */
            rangeZoneId?: Array<number>;
            /**
             * Filter by range group
             */
            rangeGroupId?: Array<number>;
            /**
             * Filter by range name
             */
            rangeName?: Array<string>;
            /**
             * Table config
             */
            config?: Array<SalaryRangesExportTableConfig>;
        },
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/salaryRange/export',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of salary range files
     * @returns SalaryRangeFile Success
     * @throws ApiError
     */
    public static getSalaryRangeFiles(): CancelablePromise<Array<SalaryRangeFile>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/salaryRange/file',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Get list of salary range names
     * @returns RangeName Success
     * @throws ApiError
     */
    public static getRangeNames({
        planId,
        limit,
        offset,
        ignorePagination,
    }: {
        /**
         * Plan id
         */
        planId?: number,
        /**
         * Number of items to return
         */
        limit?: number,
        /**
         * Number of items to skip
         */
        offset?: number,
        /**
         * If true, return all items without pagination
         */
        ignorePagination?: boolean,
    }): CancelablePromise<Array<RangeName>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/salaryRange/name',
            query: {
                'planId': planId,
                'limit': limit,
                'offset': offset,
                'ignorePagination': ignorePagination,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create a new range name
     * @returns RangeName Success
     * @throws ApiError
     */
    public static createRangeName({
        requestBody,
    }: {
        requestBody: {
            planId: number;
            name: string;
            eligibility?: Record<string, any> | null;
        },
    }): CancelablePromise<RangeName> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/salaryRange/name',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get unique range name options from SalaryRange for selectors
     * @returns any Success
     * @throws ApiError
     */
    public static getRangeNameOptions({
        planId,
    }: {
        /**
         * Plan id
         */
        planId?: number,
    }): CancelablePromise<Array<{
        /**
         * Range name id
         */
        id: number;
        /**
         * Range name
         */
        name: string;
    }>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/salaryRange/name/options',
            query: {
                'planId': planId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export range names
     * @returns any Success
     * @throws ApiError
     */
    public static exportRangeNames({
        requestBody,
    }: {
        requestBody: {
            /**
             * Filter by plan
             */
            planId?: number;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/salaryRange/name/export',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update salary range name
     * @returns any Success
     * @throws ApiError
     */
    public static updateRangeName({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: {
            name: string;
            planId: number;
            eligibility?: Record<string, any> | null;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/salaryRange/name/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete range name
     * @returns any Success
     * @throws ApiError
     */
    public static deleteRangeName({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: {
            planId: number;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/salaryRange/name/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update salary range comment
     * @returns SalaryRange Success
     * @throws ApiError
     */
    public static updateSalaryRangeCommentText({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: {
            text: string;
        },
    }): CancelablePromise<SalaryRange> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/salaryRange/{id}/comment',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of salary range zones
     * @returns RangeZone Success
     * @throws ApiError
     */
    public static getRangeZones({
        planId,
        sort,
        includeUnassigned = false,
        limit,
        offset,
        ignorePagination,
    }: {
        /**
         * Plan id
         */
        planId: number,
        /**
         * Sorting
         */
        sort?: RangeZoneSort,
        /**
         * Include zones not assigned to any SalaryRange in the plan
         */
        includeUnassigned?: boolean,
        /**
         * Number of items to return
         */
        limit?: number,
        /**
         * Number of items to skip
         */
        offset?: number,
        /**
         * If true, return all items without pagination
         */
        ignorePagination?: boolean,
    }): CancelablePromise<Array<RangeZone>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/salaryRange/zone',
            query: {
                'planId': planId,
                'sort': sort,
                'includeUnassigned': includeUnassigned,
                'limit': limit,
                'offset': offset,
                'ignorePagination': ignorePagination,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create a new range zone
     * @returns RangeZone Success
     * @throws ApiError
     */
    public static createRangeZone({
        requestBody,
    }: {
        requestBody: {
            planId: number;
            level1: string;
            level2?: string;
            level3?: string;
            eligibility?: Record<string, any> | null;
        },
    }): CancelablePromise<RangeZone> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/salaryRange/zone',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export range zones
     * @returns any Success
     * @throws ApiError
     */
    public static exportRangeZones({
        requestBody,
    }: {
        requestBody: {
            /**
             * Filter by plan
             */
            planId?: number;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/salaryRange/zone/export',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update salary range zone
     * @returns any Success
     * @throws ApiError
     */
    public static updateRangeZone({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: {
            level1: string;
            level2?: string;
            level3?: string;
            planId: number;
            eligibility?: Record<string, any> | null;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/salaryRange/zone/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete range zone
     * @returns any Success
     * @throws ApiError
     */
    public static deleteRangeZone({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/salaryRange/zone/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of salary range groups
     * @returns RangeGroup Success
     * @throws ApiError
     */
    public static getRangeGroups({
        planId,
        sort,
        limit,
        offset,
        ignorePagination,
    }: {
        /**
         * Plan id
         */
        planId?: number,
        /**
         * Sorting
         */
        sort?: RangeGroupSort,
        /**
         * Number of items to return
         */
        limit?: number,
        /**
         * Number of items to skip
         */
        offset?: number,
        /**
         * If true, return all items without pagination
         */
        ignorePagination?: boolean,
    }): CancelablePromise<Array<RangeGroup>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/salaryRange/group',
            query: {
                'planId': planId,
                'sort': sort,
                'limit': limit,
                'offset': offset,
                'ignorePagination': ignorePagination,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create a new range group
     * @returns RangeGroup Success
     * @throws ApiError
     */
    public static createRangeGroup({
        requestBody,
    }: {
        requestBody: {
            planId: number;
            level1: string;
            level2?: string;
            level3?: string;
            eligibility?: Record<string, any> | null;
        },
    }): CancelablePromise<RangeGroup> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/salaryRange/group',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update salary range group
     * @returns any Success
     * @throws ApiError
     */
    public static updateRangeGroup({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: {
            level1: string;
            level2?: string;
            level3?: string;
            planId: number;
            eligibility?: Record<string, any> | null;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/salaryRange/group/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete range group
     * @returns any Success
     * @throws ApiError
     */
    public static deleteRangeGroup({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/salaryRange/group/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export range groups
     * @returns any Success
     * @throws ApiError
     */
    public static exportRangeGroups({
        requestBody,
    }: {
        requestBody: {
            /**
             * Filter by plan
             */
            planId?: number;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/salaryRange/group/export',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of guidelines
     * @returns RangeGuideline Success
     * @throws ApiError
     */
    public static getGuidelines({
        planId,
    }: {
        /**
         * Plan id
         */
        planId?: number,
    }): CancelablePromise<Array<RangeGuideline>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/salaryRange/guideline',
            query: {
                'planId': planId,
            },
            errors: {
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create a new guide line
     * @returns RangeGuideline Success
     * @throws ApiError
     */
    public static createGuideline({
        requestBody,
    }: {
        requestBody: {
            planId: number;
            name: string;
        },
    }): CancelablePromise<RangeGuideline> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/salaryRange/guideline',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get range guideline
     * @returns RangeGuideline Success
     * @throws ApiError
     */
    public static getGuideline({
        id,
    }: {
        id: number,
    }): CancelablePromise<RangeGuideline> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/salaryRange/guideline/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update guideline
     * @returns any Success
     * @throws ApiError
     */
    public static updateGuideline({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: {
            name: string;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/salaryRange/guideline/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete guideline
     * @returns any Success
     * @throws ApiError
     */
    public static deleteGuideline({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/salaryRange/guideline/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create guideline item
     * @returns any Success
     * @throws ApiError
     */
    public static createGuidelineItem({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: {
            rangeNameId: number;
            spreadMin?: number | null;
            spreadTarget?: number | null;
            spreadMax?: number | null;
            progressionMin?: number | null;
            progressionTarget?: number | null;
            progressionMax?: number | null;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/salaryRange/guideline/{id}/item',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update guideline item
     * @returns any Success
     * @throws ApiError
     */
    public static updateGuidelineItem({
        id,
        itemId,
        requestBody,
    }: {
        id: number,
        itemId: number,
        requestBody: {
            rangeNameId?: number | null;
            spreadMin?: number | null;
            spreadTarget?: number | null;
            spreadMax?: number | null;
            progressionMin?: number | null;
            progressionTarget?: number | null;
            progressionMax?: number | null;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/salaryRange/guideline/{id}/item/{itemId}',
            path: {
                'id': id,
                'itemId': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete guideline item
     * @returns any Success
     * @throws ApiError
     */
    public static deleteGuidelineItem({
        id,
        itemId,
    }: {
        id: number,
        itemId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/salaryRange/guideline/{id}/item/{itemId}',
            path: {
                'id': id,
                'itemId': itemId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of range sets
     * @returns RangeSet Success
     * @throws ApiError
     */
    public static getRangeSets({
        planId,
        limit,
        offset,
        rangeZones,
        rangeGroups,
        search,
        sort,
    }: {
        /**
         * Plan
         */
        planId: number,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        rangeZones?: Array<number>,
        rangeGroups?: Array<number>,
        search?: string,
        /**
         * Sorting
         */
        sort?: RangeSetSort,
    }): CancelablePromise<Array<RangeSet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/salaryRange/rangeSet',
            query: {
                'planId': planId,
                'limit': limit,
                'offset': offset,
                'rangeZones': rangeZones,
                'rangeGroups': rangeGroups,
                'search': search,
                'sort': sort,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update range set
     * @returns any Success
     * @throws ApiError
     */
    public static updateRangeSet({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: {
            min?: number;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/salaryRange/rangeSet/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
